import { createApp } from "vue";
import { upperFirst, camelCase } from "lodash";
import { SwiperSlide } from "swiper/vue";

const app = createApp({});
const requireComponent = require.context("@/components/", true, /.vue$/);

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName = upperFirst(
        camelCase(
            fileName
                .split("/")
                .pop()
                .replace(/\.\w+$/, "")
        )
    );

    app.component(componentName, componentConfig.default || componentConfig);
});

app.component("SwiperSlide", SwiperSlide);

app.mount("#app");

const title = document.getElementsByClassName("js-color-last-word");

Array.from(title).forEach((item) => {
    const text = item.innerHTML.split(" ");
    item.innerHTML = text.splice(0, text.length - 1).join(" ");
    item.innerHTML += `<span class="text-orange"> ${text[text.length - 1]}</span>`;
});
